// reducer.js

const initialState = {
	accessToken: null,
	idToken: null,
	refreshToken: null,
};

const AuthReducer = (state = initialState, action) => {
	switch (action.type) {
		case "SET_TOKENS":
			return {
				...state,
				accessToken: action.payload.accessToken,
				idToken: action.payload.idToken,
				refreshToken: action.payload.refreshToken,
			};

		case "CLEAR_TOKENS":
			return {
				...state,
				accessToken: null,
				idToken: null,
				refreshToken: null,
			};

		default:
			return state;
	}
};

export default AuthReducer;
